import { RootState } from '../Store'
export const selectMovie = (state: RootState) => state.Movie;